import { useState, useEffect, useCallback } from "react";
import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";

import Toaster from "../../../components/common/Toaster";

import dashboardService from "../../../services/dashboardService";
import moment from "moment";

const CumulativeActiveAccounts = () => {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const [period] = useState({
    start_date: moment().subtract(11, "months").format("MM-DD-yyyy"),
    end_date: moment().format("MM-DD-yyyy"),
  });

  const fetchData = useCallback(
    async (mounted) => {
      try {
        setIsLoading(true);

        const result =
          await dashboardService.getMonthlyCumulativeActiveAccountsAsync(
            period.start_date,
            period.end_date
          );

        const accounts = result.map((item) => {
          item["month"] = moment(item.start_date).format("MMM yyyy");
          item["total"] = item.total_count;

          return item;
        });

        if (mounted) {
          setIsLoading(false);
          setData(accounts);
        }
      } catch (ex) {
        Toaster.Error("Something went wrong.");
        setIsLoading(false);
      }
    },
    [period]
  );

  useEffect(() => {
    let mounted = true;

    fetchData(mounted);

    return () => {
      mounted = false;
    };
  }, [fetchData]);

  return (
    <div className="card p-6">
      <div className="flex">
        <p className="text-gray-500">Active Subscribers (Cumulative)</p>
      </div>
      {isLoading && (
        <div className="flex justify-center items-center space-x-1 h-96">
          <div className="bg-blue-400 w-2 h-2 full rounded-full animate-bounce blue-circle"></div>
          <div className="bg-blue-400 w-2 h-2 full rounded-full animate-bounce blue-circle"></div>
          <div className="bg-blue-400 w-2 h-2 full rounded-full animate-bounce blue-circle"></div>
        </div>
      )}
      {!isLoading && (
        <ResponsiveContainer width="100%" height={400}>
          <AreaChart
            width={500}
            height={400}
            data={data}
            margin={{
              top: 40,
              right: 40,
              left: 20,
              bottom: 20,
            }}
          >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis
              dataKey="month"
              strokeWidth={0.6}
              axisLine={false}
              tickMargin={15}
              tickLine={false}
              tickSize={5}
              tick={{ fill: "#9ca3af", fontSize: "0.875rem" }}
            />
            <YAxis
              allowDecimals={false}
              axisLine={false}
              tickMargin={15}
              tickLine={false}
              tickSize={5}
              tick={{ fill: "#9ca3af", fontSize: "0.875rem" }}
            />
            <Tooltip />
            <Area
              type="monotone"
              fillOpacity={0.5}
              dataKey="total"
              stroke="#34D399"
              strokeWidth={1.5}
              fill="#34D399"
            />
          </AreaChart>
        </ResponsiveContainer>
      )}
    </div>
  );
};

export default CumulativeActiveAccounts;
